import React, { useContext, useEffect, useState } from "react";
import * as PIXI from "pixi.js";
import { ReactComponent as LoadingLogo } from "../../lib/assets/icons/loading-logo.svg";
import { ReactComponent as CompanyLogo } from "../../lib/assets/icons/company-logo.svg";
import {
  LoadingContainer,
  ProgressBarBar,
  ProgressBarContainer,
  ProgressBarMoving,
} from "./LoaderStyles";
import { AppContext } from "../../context/createContext";

const Loading = ({ progress, loaderIsFinished }: any) => (
  <LoadingContainer>
    <p>o</p>
    <span>o</span>
    <ProgressBarContainer>
      <LoadingLogo className="game-logo" />
      <ProgressBarBar>
        <ProgressBarMoving
          progress={progress}
          loaderIsFinished={loaderIsFinished}
        />
      </ProgressBarBar>
    </ProgressBarContainer>
    <CompanyLogo className="company-logo" />
  </LoadingContainer>
);
const useStellarLoader = (resoursesList: any, init: any) => {
  const { auth } = useContext(AppContext)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [startLoading, setstartLoading] = useState<boolean>(false)
  const [progress, setProgress] = useState<number>(0)
  const [loaderIsFinished, setLoaderIsFinished] = useState(false)

  const loader = PIXI.Loader.shared
  let loaderInited = false
  useEffect(() => {
    if (startLoading) {
      if (loaderInited) {
        return
      }
      loaderInited = true
      for (let i = 0; i < resoursesList.length; i++) {
        const element = resoursesList[i]
        loader.add(element[0], element[1])
      }

      loader.onProgress.add(p => {
        setProgress(p.progress)
      }) // called once per loaded/errored file
      loader.onError.add(() => {}) // called once per errored file
      loader.onLoad.add(() => {}) // called once per loaded file
      loader.onComplete.add(() => {
        init()
        setTimeout(() => {
          setLoaderIsFinished(true)
          setTimeout(() => {
            setLoaderIsFinished(false)
            setIsLoading(false)
          }, 2000)
          // setIsLoading(false)
        }, 10)
      }) // called once when the queued resources all load.
      loader.load()
    }
  }, [startLoading])

  useEffect(() => {
    if (auth.player_id !== "") {
      setstartLoading(true)
    }
  }, [auth.player_id])

  return { isLoading, Loading, startLoading, progress, loaderIsFinished }
}
export default useStellarLoader
